import { gql } from "graphql-request";

export const CREATE_INTERACTION = gql`
  mutation CreateInteraction($input: CreateInteractionInput!) {
    createInteraction(input: $input) {
      id
      contactID
      type
      direction
      summary
      notes
      valueAction
      meaningful
      happenedAt
    }
  }
`;

export const UPDATE_INTERACTION = gql`
  mutation UpdateInteraction($input: UpdateInteractionInput!) {
    updateInteraction(input: $input) {
      id
      type
      direction
      summary
      notes
      valueAction
      meaningful
      happenedAt
    }
  }
`;

export const ARCHIVE_INTERACTION = gql`
  mutation ArchiveInteraction($id: ID!) {
    archiveInteraction(id: $id)
  }
`;